
import { useAuth } from "../contexts/AuthContext";
import ParentDashboard from "./dashboard/ParentDashboard";
import TeacherDashboard from "./dashboard/TeacherDashboard";
import BoardDashboard from "./dashboard/BoardDashboard";

const RoleDashboard = () => {
  const { user } = useAuth();

  switch (user?.role) {
    case "parent":
      return <ParentDashboard />;
    case "teacher":
      return <TeacherDashboard />;
    case "board":
      return <BoardDashboard />;
    default:
      return <div>Unknown user role</div>;
  }
};

export default RoleDashboard;
